module.exports = __webpack_public_path__ + "static/media/quizBadgeLevel1Locked.e3ebe057.png";